// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cover_cover__NhWl2 {
  flex: 1 1;
  background: var(--White);
  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
  border-radius: 4px;
  padding: 10px;
  overflow: hidden; }
`, "",{"version":3,"sources":["webpack://./src/components/cover/cover.module.scss"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,wBAAwB;EACxB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,gBAAgB,EAAA","sourcesContent":[".cover {\n  flex: 1;\n  background: var(--White);\n  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n  border-radius: 4px;\n  padding: 10px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cover": `cover_cover__NhWl2`
};
export default ___CSS_LOADER_EXPORT___;
